import { render } from "./Summary.vue?vue&type=template&id=49da7850&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=ts"
export * from "./Summary.vue?vue&type=script&lang=ts"

import "./Summary.vue?vue&type=style&index=0&id=49da7850&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-49da7850"

export default script